import { GraphSchema } from '@camelot/server';

import { ColorSet } from './color-set';

export interface NoteType {
  id: string;
  denomination: string;
  isActive: boolean;
  colorSetId: string;
  colorSet: ColorSet;

  tenantId: string;
}

export interface NoteTypeCreationPayloadInput {
  denomination: string;
  isActive: boolean;
  colorSetId: string;
}

export interface NoteTypeModifierPayloadInput {
  id: string;
  denomination: string;
  isActive: boolean | null;
  colorSetId: string;

  updatedFields: string[];
}

export const noteTypeProps = new GraphSchema<NoteType>(['id', 'denomination', 'isActive', 'colorSetId', 'colorSet']);
